import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { UninitializedContainer } from '../../CourseInstance/Styles/UninitializedQuizInfo';

const UninitializedQuizInfo: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <UninitializedContainer id="uninitialized-quiz-container">
      <div>
        <h1>Oops!</h1>
      </div>
      <div>
        <h3>{t('This quiz is not available yet')}</h3>
      </div>
    </UninitializedContainer>
  );
};

export default UninitializedQuizInfo;
